module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical",
    attrs: {
      "router": true
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1",
      "route": {
        name: 'Generate'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "cog"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Generate License")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2",
      "route": {
        name: 'Search'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "search"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Search License")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3",
      "route": {
        name: 'CustomerList'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "user-tie"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Customer")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4",
      "route": {
        name: 'LicenseHistory'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "history"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("License History")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5",
      "route": {
        name: 'OpList'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "cloud"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Online OP")])]), _vm._v(" "), (this.$store.state.usertype === 1) ? _c('el-menu-item', {
    attrs: {
      "index": "6",
      "route": {
        name: 'UserList'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "user-friends"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("User")])]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7",
      "route": {
        name: 'EventLog'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "6%",
      "padding-right": "6%",
      "width": "150px",
      "overflow": "auto"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "list-alt"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Event Log")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6503b679","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = Sda1
// module chunks = 1